import React from 'react';
import styles from './LogsList.module.scss';
import { ScrollableContainerPresenter } from '../../atom/ScrollableContainer';
import LogItem from './LogItem';

export interface LogEntry {
  id?: string;
  timestamp?: string;
  message?: string;
  level?: 'info' | 'warning' | 'error' | 'success';
  source?: string;
}

export interface LogsListViewProps {
  logs: LogEntry[];
  isLoading?: boolean;
  maxHeight?: string;
}

export default function LogsListView({
  logs,
  isLoading = false,
  maxHeight = '400px'
}: LogsListViewProps) {

  if (isLoading) {
    return (
      <div className={styles.logsContainer}>
        <div className={styles.header}>
          <h3>Derniers Evènements</h3>
        </div>
        <div className={styles.loading}>
          <div className={styles.spinner}></div>
          <span>Chargement des évènements...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.logsContainer}>
      <div className={styles.header}>
        <h3>Derniers Evènements</h3>
       
      </div>
      
      <ScrollableContainerPresenter maxHeight={maxHeight}>
        <div className={styles.logsList}>
          {logs.length === 0 ? (
            <div className={styles.emptyState}>
              <span>Aucun évènement disponible</span>
            </div>
          ) : (
            logs.map((log) => (
              <LogItem
                key={log.id}
                timestamp={log.timestamp}
                message={log.message}
                level={log.level}
                source={log.source}
              />
            ))
          )}
        </div>
      </ScrollableContainerPresenter>
    </div>
  );
}
